<template>
	<v-container v-if="selectedPlace">
		<!-- header -->
		<v-row justify="space-between">
			<v-col cols="12" md="5" class="text-md-left">
				<!-- add payment -->
				<v-btn class="ma-2" hide-details color="primary" text @click="dialog = true">
					<v-icon left>mdi-plus</v-icon>
					Agregar
				</v-btn>
				<template v-if="paymentsForMonth && paymentsForMonth.length">
					<v-btn text icon class="ma-2" color="secondary" @click="exportToPdf">
						<v-icon>mdi-file-pdf-outline</v-icon>
					</v-btn>
					<v-btn text icon class="ma-2" color="secondary" @click="exportToCsv">
						<v-icon>mdi-file-delimited-outline</v-icon>
					</v-btn>
				</template>
			</v-col>
			<v-col cols="12" md="4" v-if="paymentsForMonth && paymentsForMonth.length">
				<v-text-field
					v-model="wordForFilter"
					dense
					outlined
					append-icon="mdi-magnify"
					label="Buscar pago"
					hide-details
					single-line
				/>
			</v-col>
		</v-row>
		<!-- payments -->
		<v-row>
			<template v-if="loading">
				<v-col v-for="loop in [1, 2, 3]" :key="loop" cols="12">
					<v-skeleton-loader type="card" />
				</v-col>
			</template>
			<v-col v-if="paymentsForMonth && paymentsForMonth.length <= 0 && !loading" cols="12">
				<data-empty title="Vacío" msj="No hay pagos registrados" />
			</v-col>
			<!-- paymentsList -->
			<v-col cols="12" class="d-relative">
				<template v-for="(item, index) in paymentsForMonth">
					<paymentsList
						:key="index"
						:word-filter="wordForFilter"
						:id-place="idPlace"
						:payments-list="groupPayments[index]"
						:title="item"
					/>
				</template>
			</v-col>
			<!-- dialog steeper form -->
			<v-dialog v-model="dialog" max-width="440" persistent>
				<v-stepper v-model="stepper" class="elevation-12">
					<v-stepper-header>
						<v-stepper-step :complete="stepper > 1" step="1">
							Tipo
						</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step :complete="stepper > 2" step="2">
							Pago
						</v-stepper-step>
					</v-stepper-header>
					<v-stepper-items>
						<v-stepper-content step="1">
							<v-radio-group v-model="visible" row>
								<v-radio label="Agregar pago por fecha" value="2"></v-radio>
								<v-radio label="Agregar pago por cuenta" value="3"></v-radio>
							</v-radio-group>
							<v-btn
								small
								text
								color="primary"
								:disabled="!Boolean(visible)"
								@click="stepper = 2"
							>
								Continuar
							</v-btn>
							<v-btn small text color="primary" @click="closeDialog">
								Cerrar
							</v-btn>
						</v-stepper-content>
						<v-stepper-content step="2">
							<payments-form-dates
								v-if="visible == 2"
								:id-place="idPlace"
								:back="() => (stepper = 1)"
								:close="closeDialog"
							/>
							<payments-form-account
								v-if="visible == 3"
								:id-place="idPlace"
								:back="() => (stepper = 1)"
								:close="closeDialog"
							/>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-dialog>
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
	name: 'Payments',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
		PaymentsList: () => import('@/components/payments/PaymentsList'),
		PaymentsFormAccount: () => import('@/components/payments/PaymentsFormAccount'),
		PaymentsFormDates: () => import('@/components/payments/PaymentsFormDates'),
	},
	data() {
		return {
			stepper: 1,
			dialog: false,
			selected: {},
			wordForFilter: '',
			visible: null,
			idPlace: '',
		};
	},
	computed: {
		...mapGetters({
			selectedPlace: 'Lodging/selectedPlace',
			loading: 'Payments/loading',
			message: 'Payments/message',
			paymentsForMonth: 'Payments/paymentsForMonth',
			groupPayments: 'Payments/groupPayments',
		}),
	},
	watch: {
		'selectedPlace.value'(newVal) {
			if (newVal) {
				this.initialFetch(newVal);
			}
		},
	},
	mounted() {
		if (this.selectedPlace) this.initialFetch(this.selectedPlace.value);
	},
	methods: {
		initialFetch() {
			this.idPlace = this.selectedPlace.value;
			this.fetchPayments(this.idPlace);
		},
		closeDialog() {
			this.dialog = false;
			this.stepper = 1;
		},
		async exportToPdf() {
			try {
				const pdf = await this.generatePdfReport(this.idPlace);
				let blob = new Blob([pdf], { type: 'application/pdf' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = 'pagos.pdf';
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		async exportToCsv() {
			try {
				const csv = await this.generateCsvReport(this.idPlace);
				let blob = new Blob([csv], { type: 'text/csv' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = 'pagos.csv';
				link.click();
			} catch (error) {
				this.snackbar({
					content: error.message,
					color: 'error',
				});
			}
		},
		...mapActions({
			fetchPayments: 'Payments/fetchPaymentsOfThePlace',
			generatePdfReport: 'Payments/generatePdfReport',
			generateCsvReport: 'Payments/generateCsvReport',
		}),
		...mapMutations({
			setPayments: 'Payments/setPayments',
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>
